import { Injectable, Optional, SkipSelf } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoundService {
  private sounds = new Map<Sound, HTMLAudioElement>();

  constructor(@Optional() @SkipSelf() thisService?: SoundService) {
    if (thisService) throw new Error('Multiple instances of SoundService');
  }

  private load(sound: Sound): void {
    const audio = new Audio();
    this.sounds.set(sound, audio);
    audio.src = sound;
    audio.load();
  }

  public async play(sound: Sound): Promise<void> {
    try {
      if (!this.sounds.has(sound)) this.load(sound);
      await this.sounds.get(sound)?.play();
    } catch (e) {
      console.warn(e);
    }
  }
}

export enum Sound {
  PING = '../../../assets/sounds/ping.mp3'
}
